import { Helmet } from 'react-helmet-async';
import '../../../assets/styles/MarketingSeo.css';
import seoImg from '../../../assets/images/seo.jpg';

const MarketingSEOPage = () => {
    return (
        <>
            <Helmet>
                <title>SEO & SEM Services – BuddyTech Solutions</title>
                <meta name="description" content="Boost your online presence with our expert SEO and SEM services to rank higher and drive targeted traffic." />
                <meta name="keywords" content="SEO, SEM, search engine optimization, search engine marketing, Google Ads, keyword strategy" />

                <meta property="og:title" content="SEO & SEM Services – BuddyTech Solutions" />
                <meta property="og:description" content="Boost your online presence with our expert SEO and SEM services to rank higher and drive targeted traffic." />
                <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
                <meta property="og:url" content="https://buddytechsolutions.in/services/marketing/seo" />
                <meta property="og:type" content="website" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="SEO & SEM Services – BuddyTech Solutions" />
                <meta name="twitter:description" content="Boost your online presence with our expert SEO and SEM services to rank higher and drive targeted traffic." />
                <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
            </Helmet>

            <div className="seo-container">
                <header className="seo-hero">
                    <div className="seo-hero-content">
                        <h1>SEO & Digital Visibility</h1>
                        <p>
                            We help businesses increase organic traffic, boost online visibility, and dominate search results with proven SEO strategies.
                        </p>
                    </div>
                    <img src={seoImg} alt="SEO Hero" className="seo-hero-img" />
                </header>

                <section className="seo-section">
                    <div className="seo-text">
                        <h2>Our SEO Services</h2>
                        <p>
                            Our team implements white-hat SEO techniques to ensure long-term rankings and performance, tailored to your industry and audience.
                        </p>
                        <ul>
                            <li>Technical SEO Audits & Fixes</li>
                            <li>On-Page & Off-Page Optimization</li>
                            <li>Keyword Research & Content Strategy</li>
                            <li>Link Building & Outreach</li>
                            <li>SEO Reporting & Analytics</li>
                        </ul>
                    </div>
                    <img src={seoImg} alt="SEO Services" className="seo-img" />
                </section>

                <section className="seo-tools">
                    <h2>Tools & Platforms</h2>
                    <div className="tools-grid">
                        <span>Google Search Console</span>
                        <span>Ahrefs</span>
                        <span>SEMrush</span>
                        <span>Yoast SEO</span>
                        <span>Google Analytics</span>
                        <span>Ubersuggest</span>
                        <span>Screaming Frog</span>
                        <span>Moz</span>
                    </div>
                </section>

                <section className="contact-options">
                    <div className="contact-card email">
                        <h2>📧 Email</h2>
                        <p>Send us an email for inquiries, support or collaboration opportunities.</p>
                        <a href="mailto:developerjayaprakash91@gmail.com" target="_blank" rel="noopener noreferrer">
                            Send Email
                        </a>
                    </div>

                    <div className="contact-card whatsapp">
                        <h2>💬 WhatsApp</h2>
                        <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
                        <a href="https://wa.me/919842084312" target="_blank" rel="noopener noreferrer">
                            Chat on WhatsApp
                        </a>
                    </div>

                    <div className="contact-card phone">
                        <h2>📞 Call Us</h2>
                        <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
                        <a href="tel:+919842084312">Call Us</a>
                    </div>
                </section>
            </div>
        </>
    );
};

export default MarketingSEOPage;
